import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCEasy icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCEasy } from '@sravni/design-system-icons'
 *
 * <CCEasy />
 * ```
 */
var CCEasy = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCEasy", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m5.368 8.136-.24-.89a1.665 1.665 0 0 1 1.18-2.044l8.37-2.23c.883-.235 1.8.295 2.038 1.177l1.462 5.424c.24.891-.29 1.807-1.18 2.044l-1.762.47", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.903 17.083h8.667c.92 0 1.666-.745 1.666-1.666V9.802c0-.92-.745-1.666-1.666-1.666H4.903c-.92 0-1.667.746-1.667 1.666v5.615c0 .92.747 1.666 1.667 1.666v0ZM3.236 11.533h12", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCEasy };
//# sourceMappingURL=CCEasy.js.map
